/* eslint-disable max-len */
/* eslint-disable max-statements */
window.tooltip = (function() {
  'use strict';

  function init(container) {
    var tooltipTriggers = container.querySelectorAll('.tooltip-trigger'),
        thElements = container.querySelectorAll('.tb th'),
        containerElement = document.querySelector('#main .gd__container'),
        containerPaddingValue,
        containerPadding,
        containerRightPosition = 0;

    if (containerElement !== null) {
      containerPaddingValue = getComputedStyle(containerElement).getPropertyValue('--gd-pi');
      containerPadding = containerPaddingValue.replace('rem', '') * 16;
      containerRightPosition = containerElement.getBoundingClientRect().right - containerPadding;
    }

    function resetTooltip() {
      const activeWrapper = document.querySelector('.tooltip-wrapper.active');
      let triggerBtn = null;

      if (activeWrapper) {
        triggerBtn = activeWrapper.querySelector('.tooltip-trigger');
      }

      tooltipTriggers.forEach(function(tooltipTrigger) {
        tooltipTrigger.parentElement.classList.remove('active');
      });
      document.documentElement.style.setProperty('--tooltip-pos', '-5px');

      thElements.forEach(function(thElement) {
        thElement.style.zIndex = '';
      });

      if (triggerBtn) {
        triggerBtn.focus();
      }
    }

    function setupTrigger(trigger) {
      const controller = new AbortController();

      if (trigger._abortController) {
        trigger._abortController.abort();
      }

      trigger._abortController = controller;

      trigger.addEventListener('click', () => {
        handleTooltipClick(trigger);
      }, { signal: controller.signal});
    }

    function handleTooltipClick(trigger) {
      let tooltipTrigger = trigger.srcElement,
          tooltipBalloon = trigger.nextElementSibling,
          tooltipWrapper = trigger.parentElement,
          buttonPosition = containerRightPosition - trigger.getBoundingClientRect().right,
          tooltipWidth,
          calcLeftPos,
          thParent;

      if (tooltipWrapper.classList.contains('active')) {
        resetTooltip();
      } else {
        resetTooltip();
        tooltipWrapper.classList.add('active');
        tooltipWidth = tooltipBalloon.offsetWidth;
        calcLeftPos = buttonPosition - tooltipWidth + 15;

        if (calcLeftPos < 0) {
          document.documentElement.style.setProperty('--tooltip-pos', `${calcLeftPos}px`);
        }

        tooltipBalloon.setAttribute('tabindex', '-1');
        tooltipBalloon.focus();
      }

      // Sticky positioned element needs a higher z-index than the next sticky element in the table.
      thParent = tooltipTrigger.closest('th');

      if (thParent) {
        thParent.style.zIndex = '20';
      }
    }

    tooltipTriggers.forEach(function(tooltipTrigger) {
      setupTrigger(tooltipTrigger);
    });

    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape') {
        resetTooltip();
      }
    });

    document.addEventListener('click', function(event) {
      if (!event.target.closest('.tooltip-trigger')) {
        resetTooltip();
      }
    });
  }

  return {
    init: () => {
      let container = document;
      init(container);
    }
  };
})();

window.tooltip.init();
